// Cards system with multi-state support
import { useState, useCallback, useEffect } from 'react';

export type CardType = 'chat' | 'blog';
export type CardState = 'hidden' | 'docked' | 'fullscreen';

export interface CardVisibility {
  chat: CardState;
  blog: CardState;
}

export const useCardVisibility = (isMobile: boolean) => {
  // Phase 1: Lock state to fixed values (chat docked, blog fullscreen)
  const visibleCards: CardVisibility = { chat: 'docked', blog: 'fullscreen' };
  const activeCard: CardType = 'blog';

  // All state change functions are no-ops for Phase 1
  const showCard = useCallback(() => {}, []);
  const hideCard = useCallback(() => {}, []);
  const toggleCard = useCallback(() => {}, []);

  return {
    visibleCards,
    activeCard,
    showCard,
    hideCard,
    toggleCard
  };
};